<script setup lang="ts">
import { computed } from 'vue';
import { Alert, AlertTitle, AlertDescription } from '@design-system/vue-ui';

export type AppAlertVariant = 'info' | 'success' | 'warning' | 'danger';

const props = defineProps<{
  variant?: AppAlertVariant;
  title?: string;
}>();

const libraryVariant = computed(() =>
  props.variant === 'danger' ? 'error' : (props.variant ?? 'info'),
);

/**
 * The design system's Alert hardcodes role="alert" (assertive) on every
 * variant. Only "danger" should interrupt; info/success/warning must stay
 * a polite role="status" to match this app's pre-existing a11y contract.
 */
const role = computed(() => (props.variant === 'danger' ? 'alert' : 'status'));
const ariaLive = computed(() => (props.variant === 'danger' ? undefined : 'polite'));
</script>

<template>
  <Alert :variant="libraryVariant" :role="role" :aria-live="ariaLive">
    <AlertTitle v-if="title">{{ title }}</AlertTitle>
    <AlertDescription><slot /></AlertDescription>
  </Alert>
</template>
